import {
    booleanAttribute,
    Component,
    computed,
    effect,
    HostBinding,
    input,
} from '@angular/core';
import { IconModule } from '@pf/shared-ui';
import { IconType } from '@pf/shared-common';

@Component({
    selector: 'cpw-action-card',
    imports: [IconModule],
    template: `
        <pf-icon [iconType]="icon()" [size]="compact() ? 'lg' : '2xl'"></pf-icon>
        <div class="card-content">
            <div class="card-title">{{ title() }}</div>
            @if (description()) {
                <div class="card-description">{{ description() }}</div>
            }
            <div class="card-actions">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styles: `
        :host {
            display: flex;
            align-items: center;
            gap: var(--pf-section-gap);
            padding: var(--pf-section-gap);
            transition: background-color 250ms ease, border-color 250ms ease;

            &.cpw-action-card-alert {
                background-color: var(--ant-error-color-outline);
                border: 1px solid var(--ant-error-color);
            }

            &.cpw-action-card-success {
                background-color: var(--ant-success-color-outline);
                border: 1px solid var(--ant-success-color);
            }

            &.cpw-action-card-compact {
                gap: var(--pf-gap);
                padding: var(--pf-gap);

                .card-content {
                    gap: 2px;

                    .card-title {
                        font-size: 0.95rem;
                    }

                    .card-description {
                        font-size: 0.8rem;
                    }
                }
            }

            .card-content {
                display: flex;
                flex-direction: column;
                gap: var(--pf-gap);

                .card-title {
                    font-size: larger;
                    font-weight: bold;
                }

                .card-actions {
                    display: flex;
                    gap: var(--pf-gap);

                    &:empty {
                        display: none;
                    }
                }
            }
        }
    `,
})
export class CpwActionCardComponent {
    actionType = input.required<'alert' | 'success'>();
    title = input.required<string>();
    description = input<string>('');
    compact = input(false, { transform: booleanAttribute });

    icon = computed((): keyof typeof IconType => {
        if (this.actionType() === 'alert') {
            return 'error';
        }
        return 'success';
    });

    @HostBinding('class')
    className?: string;

    constructor() {
        effect(() => {
            const classes = [`cpw-action-card-${this.actionType()}`];
            if (this.compact()) {
                classes.push('cpw-action-card-compact');
            }
            this.className = classes.join(' ');
        });
    }
}
